/**
 * Created by Jerker Nord on 2021-05-04.
 */
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TrueGrit} from "../../TrueGrit";
import {TrueGritGameMode} from "../../server/TrueGritGameMode";
import {gsap, TimelineMax} from "gsap";
import {TrueGritSymbol} from "../../reels/TrueGritSymbol";
import {finished} from "stream";

export class TrueGritRevertBotReelSymbols implements SimplePresentation {
    private symbolsToTurnBack:TrueGritSymbol[];

    /**
     * Removes win symbols and trigger collapse reel animation on all reels
     */

    public shouldRun(): boolean {

        if (!TrueGritGameMode.isAvalancheMode(TrueGrit.model.data.nextMode)){
            return false;
        }

        const symbols = TrueGrit.bottomReelView.getAllSymbols();

        this.symbolsToTurnBack = [];
        for (let sym of symbols){
            const posX = (<TrueGritSymbol>sym).reelPosition+1;
            const posY = 4;

            if ((<TrueGritSymbol>sym).wasTransformed &&
                !TrueGrit.model.allWinPositions[posX][posY] &&
                TrueGrit.model.data.reels[posX][posY] != "T"
            ){
                this.symbolsToTurnBack.push(<TrueGritSymbol>sym);
            }
        }

        return this.symbolsToTurnBack.length > 0;
    }

    public start(controller:SimplePresentationRunnerController): void {
        //Todo  revert the symbols

        for (let symbol of this.symbolsToTurnBack) {
            const reelPos = symbol.reelPosition;
            let turnBackTo = TrueGrit.model.data.reels[reelPos + 1][4];

            if (turnBackTo == "M"){
                turnBackTo = TrueGrit.model.gameData.xWays.symbol;
            }

            symbol.symbolName = turnBackTo;
            symbol.transformed = false;
            symbol.resetPosition();
            symbol.setCurrentStateSpriteTexture();
            symbol.wasTransformed = false;
            symbol.visible = true;
        }

        controller.finish()

    }

}